import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3698d4bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flow-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "资金流向趋势")
], -1))
const _hoisted_3 = { class: "main-body" }
const _hoisted_4 = { class: "sector-filter" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trigger-arrow" }, "▾", -1))
const _hoisted_7 = {
  key: 0,
  class: "custom-select-dropdown"
}
const _hoisted_8 = ["checked", ".indeterminate"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全选", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "chart-wrap" }
const _hoisted_12 = {
  ref: "chartRef",
  class: "flow-chart"
}
const _hoisted_13 = ["title", "onMouseenter", "onClick"]
const _hoisted_14 = { class: "line-label__name" }
const _hoisted_15 = {
  key: 0,
  class: "line-label__value"
}
const _hoisted_16 = { class: "empty-state" }
const _hoisted_17 = { class: "empty-text" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 交易日9:30开始")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["capital-flow-page", [_ctx.isDark ? 'dark' : 'light', { xp: _ctx.isXp }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["custom-select", { open: _ctx.dropdownOpen }])
          }, [
            _createElementVNode("div", {
              class: "custom-select-trigger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdownOpen = !_ctx.dropdownOpen))
            }, [
              _createElementVNode("span", {
                class: "trigger-text",
                title: _ctx.filterLabel
              }, _toDisplayString(_ctx.filterLabel), 9, _hoisted_5),
              _hoisted_6
            ]),
            (_ctx.dropdownOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("label", {
                    class: "dropdown-item dropdown-item--all",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.selectedKeys.length === _ctx.sectorList.length,
                      ".indeterminate": _ctx.selectedKeys.length > 0 && _ctx.selectedKeys.length < _ctx.sectorList.length,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedKeys.length === _ctx.sectorList.length ? (_ctx.selectedKeys = [], _ctx.onFilterChange()) : (_ctx.selectedKeys = _ctx.sectorList.map(s => s.key), _ctx.onFilterChange())))
                    }, null, 40, _hoisted_8),
                    _hoisted_9
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectorList, (s) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: s.key,
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: s.key,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
                      }, null, 40, _hoisted_10), [
                        [_vModelCheckbox, _ctx.selectedKeys]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(s.name), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 512), [
          [_vShow, _ctx.hasData]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            ref: "chartAreaRef",
            class: "chart-area",
            onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleChartAreaLeave && _ctx.handleChartAreaLeave(...args)))
          }, [
            _createElementVNode("div", _hoisted_12, null, 512),
            _withDirectives(_createElementVNode("div", {
              class: "line-labels",
              onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleLabelMouseLeave && _ctx.handleLabelMouseLeave(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLineLabelItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: _normalizeClass(["line-label", { 'line-label--solo': !!_ctx.focusedKey }]),
                  style: _normalizeStyle({
                  left: item.left + 'px',
                  top: item.top + 'px',
                  color: item.color,
                  borderColor: item.color,
                  zIndex: item.zIndex
                }),
                  title: item.value ? `${item.name} ${item.value}` : item.name,
                  onMouseenter: ($event: any) => (_ctx.onLabelEnter(item.key)),
                  onClick: _withModifiers(($event: any) => (_ctx.openKline(item.row)), ["stop"])
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1),
                  (item.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.value), 1))
                    : _createCommentVNode("", true)
                ], 46, _hoisted_13))
              }), 128))
            ], 544), [
              [_vShow, _ctx.hasData]
            ])
          ], 544),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", {
                class: "refresh-link",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
              }, "更新数据")
            ])
          ], 512), [
            [_vShow, !_ctx.hasData]
          ])
        ])
      ])
    ])
  ], 2))
}